import type { FC, ReactNode } from 'react'

import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'

/** A thin sage bar at the top of the screen while the next page loads. */
export const RouteProgress: FC = (): ReactNode => {
    const router = useRouter()
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        let timer: ReturnType<typeof setTimeout> | undefined

        const start = (url: string, { shallow }: { shallow: boolean }) => {
            if (shallow) return
            timer = setTimeout(() => setLoading(true), 120)
        }

        const done = () => {
            if (timer) clearTimeout(timer)
            setLoading(false)
        }

        router.events.on('routeChangeStart', start)
        router.events.on('routeChangeComplete', done)
        router.events.on('routeChangeError', done)

        return () => {
            router.events.off('routeChangeStart', start)
            router.events.off('routeChangeComplete', done)
            router.events.off('routeChangeError', done)
            if (timer) clearTimeout(timer)
        }
    }, [router.events])

    if (!loading) return null

    return (
        <div className='pointer-events-none fixed inset-x-0 top-0 z-[60] h-[3px] overflow-hidden bg-mint/60' role='progressbar' aria-busy='true' aria-label='Loading'>
            <div className='h-full w-2/5 rounded-full bg-sage-strong [animation:afia-progress_1.1s_ease-in-out_infinite]' />
        </div>
    )
}
